export default {
  meta: {
    title: '切换租户',
    urlName: '切换租户' // 埋点字段，上报归属的模块
  }
};
